// extracted by mini-css-extract-plugin
export default {"buttonCell":"TacticRow_buttonCell__iPKs2","buttonWrapper":"TacticRow_buttonWrapper__5lfmf"};